import {Component, Inject, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
	selector: 'app-printer-settings-input-dialog',
	templateUrl: './printer-setting-dialog.component.html',
	styleUrls: ['./printer-setting-dialog.component.scss']
})
export class PrinterSettingDialogComponent implements OnInit {
	public printerForm = new FormControl<string>('');
	public printerPort = new FormControl<string>('');
	public printerCrypto = new FormControl<boolean>(false);

	constructor(
		public dialogRef: MatDialogRef<PrinterSettingDialogComponent>,
		@Inject(MAT_DIALOG_DATA)
		public data: {
			printerValue: string;
			printerPort: string;
			printerCrypto: boolean;
		}
	) {
		this.printerForm.patchValue(data.printerValue);
		this.printerPort.patchValue(data.printerPort);
		this.printerCrypto.patchValue(data.printerCrypto);
	}

	ngOnInit() {}
	close() {
		this.dialogRef.close();
	}
	save() {
		this.dialogRef.close({
			ip: this.printerForm.value,
			port: this.printerPort.value,
			crypto: this.printerCrypto.value
		});
	}
}
